<template>
  <!-- mobile 端售卖渠道, 纯 UI 组件 -->
  <section class="sale-container">
    <div class="sale-title">{{ title }}</div>
    <div class="sale-list-container">
      <div
        class="sale-card"
        v-for="(saleChannelItem, idx) in saleChannelList"
        :key="idx"
        ref="cardRef"
        @click="jumpToLink(saleChannelItem.jumpLink, idx)"
      >
        <div class="card-image">
          <img alt="" :src="saleChannelItem.channelIcon | img2WebpFilter" />
        </div>
        <div class="card-title">{{ saleChannelItem.channelName }}</div>
        <MQrCodeFloat
          v-if="showQrCodeIdList.includes(idx)"
          class="qrcode-float-container"
          :title="saleChannelItem.qrCodeIntroTip"
          :qrCode="saleChannelItem.qrCode"
          :position="'top'"
        />
      </div>
    </div>
  </section>
</template>

<script>
import MQrCodeFloat from './MQrCodeFloat.vue'

export default {
  components: {
    MQrCodeFloat
  },
  data() {
    return {
      showQrCodeIdList: []
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    saleChannelList: {
      type: Array,
      default: () => []
    },
    frogPath: {
      type: String,
      default: ''
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  methods: {
    jumpToLink(jumpLink, idx) {
      if (jumpLink) {
        this.sendEvent()
        location.href = jumpLink
      } else if (this.showQrCodeIdList.includes(idx)) {
        this.showQrCodeIdList = []
      } else {
        this.sendEvent()
        this.showQrCodeIdList = [idx]
      }
    },
    sendEvent() {
      const commonParams = [
        { key: 'devicetype', value: 'mobile' },
        { key: 'pageType', value: this.pageType }
      ]
      this.$addFrog(this.frogPath, commonParams)
    }
  }
}
</script>

<style lang="less" scoped>
.sale-container {
  box-sizing: border-box;
  padding: 0.6rem 0.16rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f6f6f6;
  flex-direction: column;
  .sale-title {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 600;
    font-size: 0.2rem;
    line-height: 0.28rem;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
    margin-bottom: 0.4rem;
  }
  .sale-list-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    .sale-card {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 1rem;
      padding: 0.2rem 0.5rem;
      display: flex;
      align-items: center;
      background: #ffffff;
      border-radius: 0.08rem;
      &:not(:last-child) {
        margin-bottom: 0.16rem;
      }
      .card-image {
        width: 0.6rem;
        height: 0.6rem;
        margin-right: 0.16rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .card-title {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 600;
        font-size: 0.16rem;
        line-height: 0.22rem;
        color: #000000;
      }
      .qrcode-float-container {
        position: absolute;
        top: -221px;
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
      }
    }
  }
}
</style>
